import ProfilePicture from "@/components/common/profile-picture";
import { useModal } from "@/providers/modal-provider";
import { ModalType } from "@/types/modal-type";
import { UserCircleIcon } from "lucide-react";
import Link from "next/link";

type FounderDetailsCardProps = {
	name: string;
	image?: string | null;
	designation: string;
	linkedinUrl?: string;
	username?: string | null;
	isVerified?: boolean;
	isFounder?: boolean;
};

const FounderDetailsCard = ({
	name,
	image,
	designation,
	username,
	isVerified = false,
	isFounder = false,
}: FounderDetailsCardProps) => {
	const { closeModal } = useModal();

	const handleOnClick = () => {
		window.rudderanalytics?.track("click", {
			target_url: `/${username}`,
			link_text: username || name,
		});

		closeModal(ModalType.ProductDetails, { disableURLChange: true });
	};

	return (
		<Link
			href={username ? `/${username}` : "#"}
			className="flex items-center gap-2 rounded-md border border-gray-200 px-3 py-4"
			onClick={handleOnClick}
		>
			{image ? (
				<ProfilePicture
					profilePictureUrl={image}
					alternateText={name}
					isFounder={isFounder}
					isVerified={isVerified}
					className={{
						container: `h-11 w-11 rounded-full ${isVerified && isFounder ? "p-0.5" : ""}`,
						image: "rounded-full text-gray-600",
						badgeImage: "-bottom-4 h-8 w-8",
					}}
				/>
			) : (
				<UserCircleIcon className="h-11 w-11 stroke-gray-300 stroke-1" />
			)}

			<div>
				<p className="font-semibold">{name}</p>

				<div className="flex items-center gap-2">
					<p className="text-sm capitalize text-gray-500">{designation}</p>
				</div>
			</div>
		</Link>
	);
};

export default FounderDetailsCard;
